import { Content } from "../../types/content.interface";

export const educationsData: Content[] = [
  {
    enSubtitle: "Sogang University",
    krSubtitle: "서강대학교",
    isDisplay: true,
    details: [
      {
        enText: "B.S. degree expected in Computer Engineering",
        krText: "서강대학교 컴퓨터공학과 재학 중",
        date: "(20.03 ~ 26.08)",
        isDisplay: true,
      },
      {
        enText: "2021 President of the engineering college",
        krText: "2021 서강대학교 공과대학 제23대 학생회장",
        date: "(21.01 ~ 21.12)",
        isDisplay: true,
      },
    ],
  },
];
